<template>
  <d2-container>
    <el-button
      v-permission:function="['mapManger:btn_add']"
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
    >添加</el-button>
    <template slot="header">
      <el-input
        clearable
        @keyup.enter.native="getSearch"
        style="width: 200px;margin-right: 20px;"
        class="filter-item"
        placeholder="请输入页面标题"
        size="small"
        v-model="listQuery.keyword"
      ></el-input>
      <el-select
        @keyup.enter.native="getSearch"
        v-model="listQuery.status"
        clearable
        placeholder="请选择状态"
        size="small"
        style="margin-top:5px;margin-right: 20px;"
      >
        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button @click="getSearch" class="filter-item" type="primary" icon="search" size="small">搜索</el-button>
    </template>
    <el-table
      v-loading="listLoading"
      size="small"
      :key="tableKey"
      :data="list"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
    >
      <el-table-column align="center" label="id" width="160">
        <template slot-scope="scope">
          <span>{{scope.row.id}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="页面标题">
        <template slot-scope="scope">
          <span>{{scope.row.title}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="页面名称">
        <template slot-scope="scope">
          <span>{{scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="地图类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 0">普通</span>
          <span v-if="scope.row.type == 1">大赛</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="关联活动id">
        <template slot-scope="scope">
          <span>{{scope.row.activityId }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">下架</span>
          <span v-if="scope.row.status == 1">上架</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="success"
            v-permission:function="['mapManger:btn_edit']"
            @click="getEdit(scope.row.id)"
          >编辑</el-button>
          <span v-if="scope.row.status == 1" style="margin-left:10px">
            <el-button
              size="small"
              type="warning"
              v-permission:function="['mapManger:btn_lower']"
              @click="getLowerShelf(scope.row.id)"
            >下架</el-button>
          </span>
          <span v-if="scope.row.status == 0" style="margin-left:10px">
            <el-button
              size="small"
              type="primary"
              v-permission:function="['mapManger:btn_put']"
              @click="getPutOnShelves(scope.row.id)"
            >上架</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>

    <!-- 页码 -->
    <template slot="footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="listQuery.currentPage"
        :page-sizes="[10,20,30, 50]"
        :page-size="listQuery.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </template>
  </d2-container>
</template>
<script>
import { getMapList, getMapStatus } from '@/api/demo/map/index'
export default {
  name: 'mapManger',
  data () {
    return {
      mapManger_btn_add: false,
      mapManger_btn_edit: false,
      mapManger_btn_lower: false,
      mapManger_btn_put: false,
      tableKey: 0,
      list: [],
      total: null,
      listLoading: true, // 加载圈圈
      listQuery: {
        currentPage: 1,
        pageSize: 20,
        keyword: '',
        status: 1
      },
      statusList: [
        { id: 0, name: '下架' },
        { id: 1, name: '上架' }
      ]
    }
  },
  created () {
    let that = this
    that.getList()
  },
  watch: {
    $route (to, from) {
      this.getList()
    }
  },
  methods: {
    getList (val) {
      let that = this
      if (val) {
        that.listQuery.currentPage = val
      } else {
        that.listQuery.currentPage = 1
      }
      that.listLoading = true
      getMapList(that.listQuery).then(res => {
        that.list = res.records
        that.total = Number(res.total)
        that.listLoading = false
      })
    },
    getSearch () {
      this.getList()
    },
    getAdd () {
      this.$router.push('./map/addMap')
    },
    getEdit (id) {
      this.$router.push({
        path: './map/addMap',
        query: {
          id: id
        }
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.listQuery.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.listQuery.currentPage = val
      this.getList(val)
    },
    // 下架
    getLowerShelf (id) {
      let data = {
        status: 0
      }
      getMapStatus(id, data).then(res => {
        this.$message({
          message: '下架成功',
          type: 'success'
        })
        this.getList()
      })
    },
    // 上架
    getPutOnShelves (id) {
      let data = {
        status: 1
      }
      getMapStatus(id, data).then(res => {
        this.$message({
          message: '下架成功',
          type: 'success'
        })
        this.getList()
      })
    }
  }
}
</script>
<style scoped>
</style>
